import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import MnyWiresResultPanel from "./MnyWiresResultPanel";

export default function MnyWiresPanel() {


    function mainComponent() {
            return <MnyWiresResultPanel/>;
    }

    return(<>
        <Container fluid>
            <Row>
                <Col style={{padding:0}}>
                    {mainComponent()}
                </Col>
            </Row>
            <Row>
                <br/>
            </Row>
        </Container>
    </>);

}